import React from 'react';
import './PageNotFound.css';
function PageNotFound(){
    return (
        <div className='fourofour'>
			<h1>404 Error
            <br />
            <br />
            Page not Found</h1>
            <br />
            <img src="https://cdn.7tv.app/emote/61f18e81170449495610fc7a/3x.webp" alt="catSad" />
            <img src="https://cdn.7tv.app/emote/64d6812e6c817df67d590db5/3x.webp" alt="oopsie" />
            
		</div>
    );
}

export default PageNotFound;
